export default "__VITE_ASSET__Pp_IQTQe__"